export default function TimeService(userService) {
    'ngInject';

    const TIMEZONE_UK = 'Europe/London';
    const defaultDateFormat = 'YYYY-MM-DD';
    const atcApiDateFormat = 'DDMMYY';

    return {
        getUkTime,
        getDateInUserRegionFormat,
        getDateInUserRegionFormatOrCurrentDate,
        getSelectedMinutesOption,
        convertTimeToMilliseconds,
        parseAndFormat,
        parse,
        format,
        parseAtcApiFormat,
        isToday,
    };

    function parseAndFormat(stringDate, dateFormat) {
        if (!stringDate) {
            return null;
        }
        return moment(stringDate, dateFormat || userService.getRegionalSettings().dateFormat)
            .format(defaultDateFormat);
    }

    function parse(stringDate) {
        return moment(stringDate, userService.getRegionalSettings().dateFormat);
    }

    function format(momentDate) {
        return momentDate.format(userService.getRegionalSettings().dateFormat);
    }

    function parseAtcApiFormat(stringDate) {
        return moment(stringDate, atcApiDateFormat);
    }

    function getDateInUserRegionFormat(inputDate) {
        const {dateFormat} = userService.getRegionalSettings();
        return moment(inputDate, dateFormat);
    }

    function getDateInUserRegionFormatOrCurrentDate(inputDate) {
        return inputDate ? getDateInUserRegionFormat(inputDate) : moment();
    }

    function convertTimeToMilliseconds(value) {
        return moment.duration(value).asMilliseconds();
    }

    function getUkTime() {
        return moment().tz(TIMEZONE_UK);
    }

    function getSelectedMinutesOption(timeOptions, minutes) {
        let index = 0;
        if ((minutes > 0) && (minutes <= 15)) {
            index = 1;
        } else if ((minutes > 15) && (minutes <= 30)) {
            index = 2;
        } else if ((minutes > 30) && (minutes <= 45)) {
            index = 3;
        } else if (minutes > 45) {
            index = 0;
        }
        return timeOptions[index];
    }

    function isToday(date) {
        const now = moment();
        return date.date() === now.date()
            && date.month() === now.month()
            && date.year() === now.year();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/timeService.js